import { tv, VariantProps } from '@/utils/tv'

export const propertyMosaic = tv({
  slots: {
    base: ['grid grid-cols-4 md:grid-cols-6 auto-rows-[240px] gap-1'],
    item: ['relative', 'self-stretch', 'w-full h-full'],
    image: ['w-full h-full', 'object-cover', 'cursor-pointer']
  }
})

export type PropertyMosaicVariantProps = VariantProps<typeof propertyMosaic>
